const INTERNATIONAL_PREFIX = "+";
const WHITESPACE = /\s/;

/**
 * Phone numbers are stored as the national number. A number stored with spaces
 * carries its country code as the first group, so only that form gets a plus sign.
 */
export const formatPhoneNumber = (phoneNumber: string): string => {
  const trimmedPhoneNumber = phoneNumber.trim();
  const hasSeparatedCountryCode =
    WHITESPACE.test(trimmedPhoneNumber) && !trimmedPhoneNumber.startsWith(INTERNATIONAL_PREFIX);
  return hasSeparatedCountryCode
    ? `${INTERNATIONAL_PREFIX}${trimmedPhoneNumber}`
    : trimmedPhoneNumber;
};
